import { Routes, Route } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import HowToUse from '../pages/HowToUse';
import Training from '../pages/Training';
import Organization from '../pages/Organization';
import ProjectPlan from '../pages/ProjectPlan';
import ResponsePlan from '../pages/ResponsePlan';
import Workflows from '../pages/Workflows';
import WarRoom from '../pages/WarRoom';
import Communications from '../pages/Communications';
import ReadinessDashboard from '../pages/ReadinessDashboard';
import ReadinessAssessment from '../pages/ReadinessAssessment';
import CrisisResponse from '../pages/CrisisResponse';
import IncidentAssessment from '../pages/IncidentAssessment';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/response-plan" element={<ResponsePlan />} />
      <Route path="/crisis-response" element={<CrisisResponse />} />
      <Route path="/crisis-response/assessment" element={<IncidentAssessment />} />
      <Route path="/war-room" element={<WarRoom />} />
      <Route path="/communications" element={<Communications />} />
      <Route path="/workflows" element={<Workflows />} />
      <Route path="/organization" element={<Organization />} />
      <Route path="/readiness" element={<ReadinessDashboard />} />
      <Route path="/readiness/assessment" element={<ReadinessAssessment />} />
      <Route path="/how-to-use" element={<HowToUse />} />
      <Route path="/training" element={<Training />} />
      <Route path="/project-plan" element={<ProjectPlan />} />
    </Routes>
  );
}